import React from 'react';

const IconCross = (props) => {
  const color = props.color === 'black' ? "#222222" : "#999999"
  const width = props.width ? props.width : '14';
  return (
    <svg {...props} width={width} height={width} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.777778 0L0 0.777778L6.22222 7L0 13.2222L0.777778 14L7 7.77778L13.2222 14L14 13.2222L7.77778 7L14 0.777778L13.2222 0L7 6.22222L0.777778 0Z" fill={color}/>
    </svg>
  );
}

export default IconCross;